var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49994 14.5084L4.40827 11.425L5.58327 10.2417L7.49994 12.1584L14.4083 5.2417L15.5833 6.42503L7.49994 14.5084Z",
    fill: "#2768EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C8.02218 20 6.08879 19.4135 4.4443 18.3147C2.7998 17.2159 1.51808 15.6541 0.761205 13.8268C0.00432814 11.9996 -0.193699 9.98891 0.192153 8.0491C0.578006 6.10929 1.53039 4.32746 2.92892 2.92894C4.32745 1.53041 6.10927 0.578004 8.04908 0.192152C9.9889 -0.1937 11.9996 0.00433286 13.8268 0.761209C15.6541 1.51809 17.2159 2.79981 18.3147 4.4443C19.4135 6.08879 20 8.02219 20 10C20 12.6522 18.9464 15.1957 17.0711 17.0711C15.1957 18.9464 12.6522 20 10 20ZM10 1.66667C8.35182 1.66667 6.74066 2.15541 5.37025 3.07109C3.99984 3.98677 2.93173 5.28826 2.30099 6.81098C1.67026 8.33369 1.50523 10.0092 1.82678 11.6258C2.14832 13.2423 2.94199 14.7271 4.10743 15.8926C5.27287 17.058 6.75774 17.8517 8.37425 18.1732C9.99076 18.4948 11.6663 18.3297 13.189 17.699C14.7118 17.0683 16.0132 16.0002 16.9289 14.6298C17.8446 13.2593 18.3333 11.6482 18.3333 10C18.3333 7.78987 17.4554 5.67025 15.8926 4.10745C14.3298 2.54465 12.2101 1.66667 10 1.66667Z",
    fill: "#2768EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.a2637503c8546aaa4c37a68d9b36dde2.svg";
export { ForwardRef as ReactComponent };